module.exports = __webpack_public_path__ + "static/media/rss_badge.dd0f8e7c.png";